import React, { Fragment } from "react";
import { Link as RouterLink } from "react-router-dom";

import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import PersonIcon from "@material-ui/icons/Person";
import PinDropIcon from "@material-ui/icons/PinDrop";
import BlockIcon from "@material-ui/icons/Block";
import FlightIcon from "@material-ui/icons/Flight";

import {
  MEDIA_THUMBNAIL_URL,
  PLACEHOLDER_IMG_360x360_URL,
  PLACEHOLDER_IMG_360x360_ERROR_URL,
  IMG_BG_COLOR,
} from "../../config";
import StatusChip from "./StatusChip";
import KeyValue from "../display/KeyValue";
import { fromUnixtime } from "../../utils/time";
import ListItem from "../display/ListItem";
import UserChip from "../user/UserChip";
import { getSpamTypeValue } from "../../utils/helpers";

import UserStatusChip from "../travalours/StatusChip";
import TravelCardStatusChip from "../travel-cards/StatusChip";
import TripStatusChip from "../trips/StatusChip";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    margin: "auto",
    //backgroundColor: "#212121",
    marginTop: theme.spacing(1),
  },
  imgTC: {
    width: 150,
    height: 90,
    margin: "auto",
    objectFit: "cover",
    backgroundColor: IMG_BG_COLOR,
  },
  imgUser: {
    width: 100,
    height: 100,
    margin: "auto",
    objectFit: "cover",
    backgroundColor: IMG_BG_COLOR,
  },
}));

export default function ResultGrid({ spam }) {
  const classes = useStyles();

  return (
    <Paper className={classes.paper}>
      <ListItem
        header={
          <Box display="flex">
            {spam.entity === 52 && <PersonIcon style={{ marginRight: 10 }} />}
            {spam.entity === 48 && <PinDropIcon style={{ marginRight: 10 }} />}
            {spam.entity === 59 && <FlightIcon style={{ marginRight: 10 }} />}
            <Link
              color="inherit"
              component={RouterLink}
              to={
                spam.entity === 48
                  ? `/travel-card/${spam.entityId}`
                  : spam.entity === 52
                  ? `/travalour/${spam.entityId}`
                  : spam.entity === 59
                  ? `/trip/${spam.entityId}`
                  : null
              }
              underline="none"
              variant="subtitle2"
            >
              {`${spam.name}`}
            </Link>
          </Box>
        }
        contentLeft={
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            height="100%"
            style={{ marginTop: 10 }}
          >
            <Box>
              <img
                className={spam.entity === 48 ? classes.imgTC : classes.imgUser}
                alt=""
                src={
                  !!spam.image
                    ? `${MEDIA_THUMBNAIL_URL}/${spam.image}?width=240`
                    : PLACEHOLDER_IMG_360x360_URL
                }
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = PLACEHOLDER_IMG_360x360_ERROR_URL;
                }}
              />
            </Box>
            <Box>
              <StatusChip status={spam.status} />
            </Box>
            <Box>
              {spam.entity === 52 && (
                <UserStatusChip status={spam.entityStatus} />
              )}
              {spam.entity === 48 && (
                <TravelCardStatusChip status={spam.entityStatus} />
              )}
              {spam.entity === 59 && (
                <TripStatusChip status={spam.entityStatus} />
              )}
            </Box>
          </Box>
        }
        contentRight={
          <Fragment>
            <Box display="flex" alignItems="center">
              <BlockIcon
                style={{
                  fontSize: 15,
                  marginLeft: 5,
                  marginRight: 5,
                  color: "#C2C2C2",
                }}
              />
              <Box>
                <Typography variant="caption">
                  {getSpamTypeValue(spam.type)}
                </Typography>
                {!!spam.reporter.comments && (
                  <Typography variant="caption" style={{ fontStyle: "italic" }}>
                    {`  ("${spam.reporter.comments}")`}
                  </Typography>
                )}
              </Box>
            </Box>
            <KeyValue
              keyName={`Reported On : ${fromUnixtime(
                spam.reporter.reportedOn
              )}`}
              value={<UserChip user={{ ...spam.reporter, type: 2 }} />}
            />
            {!!spam.verifier && (
              <Fragment>
                <KeyValue
                  keyName={`Verified On : ${fromUnixtime(
                    spam.verifier.verifiedOn
                  )}`}
                  value={
                    <Box>
                      <UserChip user={{ ...spam.verifier, type: 1 }} />
                      <Typography
                        variant="caption"
                        display="block"
                        style={{ fontStyle: "italic" }}
                      >
                        {`"${spam.verifier.comments}"`}
                      </Typography>
                    </Box>
                  }
                />
              </Fragment>
            )}
          </Fragment>
        }
      />
    </Paper>
  );
}
